<template>
  <div class="auth__header">
    <ReturnButton v-if="!noReturn" top />
    <Image :source="content.image" class="auth__header-image" />
    <h1 class="auth__header-title section__header">{{ content.title }}</h1>
    <RawHtml :html="content.description" />
  </div>
</template>

<script>
import { Image, RawHtml } from '@/components/global'
import { ReturnButton } from '@/components/small'
import { ContentPropMixin } from '@/mixins'

export default {
  name: 'AuthHeader',
  mixins: [ContentPropMixin],
  components: { Image, RawHtml, ReturnButton },
  props: {
    noReturn: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
